"use client";
import { PropsWithChildren, forwardRef } from "react";
import { Link as NextLink } from "next-view-transitions";

import { makeLinkTarget } from "./makeLinkTarget";
import type { LinkProps } from "./Link.d";

export const Link = forwardRef<HTMLAnchorElement, PropsWithChildren<LinkProps>>(
	({ children, href, target = makeLinkTarget(href), ...props }, ref) => (
		<NextLink {...props} ref={ref} href={href} target={target} role="link">
			{children}
		</NextLink>
	)
);

Link.displayName = "Link";

export default Link;
